import { useModuleBEM } from "@b2bportal/core-themes";
import type { ActivityReservation } from "@b2bportal/rbc-activities-api";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./ActivityReservationDetailContent.module.scss";

interface ActivityReservationDetailContentProps {
  reservation: ActivityReservation;
  className?: string;
}

export const ActivityReservationDetailContent = ({
  reservation,
  className,
}: ActivityReservationDetailContentProps) => {
  const [block, cn] = useModuleBEM(styles, "ActivityReservationDetailContent");
  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("header")}>
        <h1 className={cn("title")}>{reservation.activityDetails?.name}</h1>
        <p className={cn("confirmation")}>
          <Trans
            i18nKey="confirmationCodeLabelAndCode"
            values={{
              code: reservation.customerReservationId,
            }}
            components={[<b />]}
          />
        </p>
      </div>
    </div>
  );
};
